import React from 'react';
import { Typography } from '@material-ui/core';
import InboxIcon from '@material-ui/icons/Inbox';
import SectionCard from '../section-card';

/**
 * Card profissional de empty state. Usado em todas as listagens quando
 * não há registros a exibir. Substitui o "No records to display" padrão
 * da MyMaterialTable.
 *
 * Props:
 *  - icon: elemento (default <InboxIcon />)
 *  - title: string (default "Nenhum registro encontrado")
 *  - description: string — texto complementar em 1-2 linhas
 *  - context: SectionCard context (default "info")
 */
function EmptyStateCard({ icon, title, description, context = 'info' }) {
    const iconEl = icon || <InboxIcon style={{ fontSize: 56, color: '#bdbdbd' }} />;
    return (
        <SectionCard context={context} title={null} divider={false}>
            <div style={{ textAlign: 'center', padding: 32 }}>
                {iconEl}
                <Typography variant="h6" style={{ fontWeight: 600, marginTop: 12 }}>
                    {title || 'Nenhum registro encontrado'}
                </Typography>
                {description && (
                    <Typography variant="body2" style={{ color: '#888', marginTop: 4 }}>
                        {description}
                    </Typography>
                )}
            </div>
        </SectionCard>
    );
}

export default EmptyStateCard;
